module.exports = __webpack_public_path__ + "static/media/main.a3fa285b.png";